import { memo, useRef } from 'react';
import BarChartVertical from '@/components/BarChartVertical';
import { useTheme } from '@simplywallst/ui-core';

export interface Props {
  companyName: string;
  industryName: string;
  marketName: string;
  revenueGrowthAnnual: number | null;
  earningsGrowthAnnual: number | null;
  revenueGrowthAnnualMarket: number;
  netIncomeGrowthAnnualMarket: number;
  revenueGrowthAnnualIndustry: number;
  netIncomeGrowthAnnualIndustry: number;
  earningsGrowthAnnualFormatted: string;
  netIncomeGrowthAnnualIndustryFormatted: string;
  netIncomeGrowthAnnualMarketFormatted: string;
  revenueGrowthAnnualFormatted: string;
  revenueGrowthAnnualIndustryFormatted: string;
  revenueGrowthAnnualMarketFormatted: string;
}

const FutureGrowth = ({
  companyName,
  industryName,
  marketName,
  revenueGrowthAnnual,
  earningsGrowthAnnual,
  revenueGrowthAnnualMarket,
  netIncomeGrowthAnnualMarket,
  revenueGrowthAnnualIndustry,
  netIncomeGrowthAnnualIndustry,
  earningsGrowthAnnualFormatted,
  netIncomeGrowthAnnualIndustryFormatted,
  netIncomeGrowthAnnualMarketFormatted,
  revenueGrowthAnnualFormatted,
  revenueGrowthAnnualIndustryFormatted,
  revenueGrowthAnnualMarketFormatted,
}: Props) => {
  const theme = useTheme();

  const chartsRef = useRef([
    'forecast annual earnings growth',
    'forecast annual revenue growth',
  ]);

  const { current: charts } = chartsRef;

  const keysRef = useRef(['Company', 'Industry', 'Market']);

  const { current: keys } = keysRef;

  const entities = {
    [charts[0]]: {
      [keys[0]]: earningsGrowthAnnual,
      [keys[1]]: netIncomeGrowthAnnualIndustry,
      [keys[2]]: netIncomeGrowthAnnualMarket,
    },
    [charts[1]]: {
      [keys[0]]: revenueGrowthAnnual,
      [keys[1]]: revenueGrowthAnnualIndustry,
      [keys[2]]: revenueGrowthAnnualMarket,
    },
  };

  const entitiesFormatted = {
    [charts[0]]: {
      [keys[0]]: earningsGrowthAnnualFormatted,
      [keys[1]]: netIncomeGrowthAnnualIndustryFormatted,
      [keys[2]]: netIncomeGrowthAnnualMarketFormatted,
    },
    [charts[1]]: {
      [keys[0]]: revenueGrowthAnnualFormatted,
      [keys[1]]: revenueGrowthAnnualIndustryFormatted,
      [keys[2]]: revenueGrowthAnnualMarketFormatted,
    },
  };

  const entityTooltips = {
    [charts[0]]: {
      [keys[0]]: companyName,
      [keys[1]]: industryName,
      [keys[2]]: marketName,
    },
    [charts[1]]: {
      [keys[0]]: companyName,
      [keys[1]]: industryName,
      [keys[2]]: marketName,
    },
  };

  return (
    <BarChartVertical
      charts={charts}
      entities={entities}
      entitiesFormatted={entitiesFormatted}
      entityTooltips={entityTooltips}
      keys={keys}
      colors={theme.chart.barChart.futureGrowth.colors}
      titleColors={theme.chart.barChart.futureGrowth.titleColors}
      height={250}
    />
  );
};

export default memo(FutureGrowth);
